module.exports = __webpack_public_path__ + "img/ug431.a0af2e84.png";